import { MDBAlert, MDBCard, MDBCardBody, MDBCol, MDBInput, MDBRow, MDBTextArea } from 'mdb-react-ui-kit'
import { React, useState } from "react";
import contactImg from "../assets/images/contactimg.png";
import backdrop from "../assets/images/backdrop.png";
import { customPremium, gymcontactus } from '../../services/apiServices'

function GymContact({ contactData, bussinessInfo }) {
    const [Alerttxt, setAlerttxt] = useState("");
    const [contact, SetContactForm] = useState({
        fname: "",
        lname: "",
        email: "",
        number: "",
        inquiry: ""
    });

    function updateContactForm(value) {
        return SetContactForm((prev) => {
            return { ...prev, ...value };
        });
    }

    const [ErrorContactInfo, setErrorContactInfo] = useState({});


    const isEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }


    let validateForm = (e) => {
        let errors = {};
        if (isEmpty(contact.fname)) {
            errors.fname = "Name can't be blank";
        }
        if (isEmpty(contact.lname)) {
            errors.lname = "Name can't be blank";
        }
        if (isEmpty(contact.email)) {
            errors.email = "Field can't be blank";
        }
        else if (!isEmail(contact.email)) {
            errors.email = "Please enter valid email";
        }
        if (isEmpty(contact.number)) {
            errors.number = "Number can't be blank";
        }
        // else if (!isValidPhoneNumber(contact.number)) {
        //     errors.number = "Please enter valid Number";
        // }
        if (isEmpty(contact.inquiry)) {
            errors.inquiry = "Text can't be blank";
        }
        if (isEmpty(errors)) {
            return true;
        } else {
            return errors;
        }
    };


    const isEmpty = (thing) => {
        let empty = false;
        switch (typeof thing) {
            case 'undefined':
                empty = true;
                break;
            case 'string':
                if (thing.trim().length === 0) {
                    empty = true;
                }
                break;
            case 'object':
                if (thing === null) {
                    empty = true;
                } else if (Object.keys(thing).length === 0) {
                    empty = true;
                }
                break;
            default:
                empty = false;
        }

        return empty;
    }

    const sendingMail = async (e) => {
        e.preventDefault();
        console.log("Triggered sendingMail");
        console.log("ContactInfo", contact);

        let errors = validateForm(e);

        if (errors === true) {
            setErrorContactInfo({});

            try {
                const update = {
                    ...contact,
                    bussmail: bussinessInfo?.businessEmail,
                    bussName: bussinessInfo?.businessName,
                    bussNumber: bussinessInfo?.contactNumber,
                    bussLogo: bussinessInfo?.logourl
                }
                console.log(update, 'update');

                const saverep = await gymcontactus(update);

                console.log(saverep, '777');

                if ((saverep.status === 200)) {
                    setAlerttxt("Email sent successfully!");

                    SetContactForm({
                        fname: "",
                        lname: "",
                        email: "",
                        number: "",
                        inquiry: ""
                    });
                }
                else {
                    setAlerttxt("Failed to send email. Please try again.")
                }

            } catch (err) {
                console.error("Error while sending email:", err);
                alert("Something went wrong. Please try again later.");
            }

        } else {
            setErrorContactInfo(errors);
        }
    };
    return (
        <>
            <div className='palnsection position-relative' style={{ backgroundColor: contactData.backgroundcolor }}>
                <div className='container'>
                    <div className='sectionheader'>
                        <div className="plansubtile" dangerouslySetInnerHTML={{ __html: contactData.subtitle || "<p>Get in touch</p>" }} />
                        <div dangerouslySetInnerHTML={{ __html: contactData.title || "<h4>Contact with us for more</h4>" }} />

                    </div>
                    <MDBRow className='align-items-center' >
                        <MDBCol sm={12} md={5} className='mb-4 mb-md-0' style={{
                            flex: 1,
                            padding: '1rem',
                            order: contactData.contentposition === 'left' ? 1 : 0 // Changed this line
                        }}>
                            <div className='contact-section'
                            >
                                {contactData.image && (
                                    <img src={contactData?.image ? contactData.image : contactImg} alt="" />
                                )}
                            </div>
                        </MDBCol>
                        <MDBCol sm={12} md={7} style={{
                            order: contactData.contentposition === 'left' ? 0 : 1
                        }}>
                            <MDBCard className='shadow-3' style={{

                                backgroundColor: contactData.cardbackground || '#ffffff'
                            }}>
                                <MDBCardBody>
                                    <div className='contact-header text-center mb-3'>
                                        <div
                                            className={`ps-0 contact_head`}
                                            dangerouslySetInnerHTML={{ __html: contactData.description || <h5>We'd love to hear from you!<br /> Let's get in touch</h5> }} />
                                    </div>

                                    <div className='px-3 py-4 bg-white rounded-5'>
                                        <MDBRow>
                                            <MDBCol sm={12} md={6}>
                                                <div className='mb-4'>
                                                    <MDBInput label="First Name" id="formControlLg" type="text" size="lg"
                                                        value={contact.fname}
                                                        onChange={(e) => updateContactForm({ fname: e.target.value })}
                                                        required
                                                    />
                                                    {ErrorContactInfo?.fname && (<p className="text-danger">{ErrorContactInfo.fname}</p>)}
                                                </div>
                                            </MDBCol>
                                            <MDBCol sm={12} md={6}>
                                                <div className='mb-4'>
                                                    <MDBInput label="Last Name" id="formControlLg" type="text" size="lg"
                                                        value={contact.lname}
                                                        onChange={(e) => updateContactForm({ lname: e.target.value })}
                                                        required
                                                    />
                                                    {ErrorContactInfo?.lname && (<p className="text-danger">{ErrorContactInfo.lname}</p>)}
                                                </div>
                                            </MDBCol>
                                            <MDBCol sm={12} md={6}>
                                                <div className='mb-4'>
                                                    <MDBInput label="Mobile No" id="formControlLg" type="number" size="lg"
                                                        value={contact.number}
                                                        onChange={(e) => updateContactForm({ number: e.target.value })}
                                                        required
                                                    />
                                                    {ErrorContactInfo.number && (<p className="text-danger">{ErrorContactInfo.number}</p>)}
                                                </div>
                                            </MDBCol>
                                            <MDBCol sm={12} md={6}>
                                                <div className='mb-4'>
                                                    <MDBInput label="E-mail id" id="formControlLg" type="text" size="lg"
                                                        value={contact.email}
                                                        onChange={(e) => updateContactForm({ email: e.target.value })}
                                                        required
                                                    />
                                                    {ErrorContactInfo.email && (<p className="text-danger">{ErrorContactInfo.email}</p>)}
                                                </div>
                                            </MDBCol>
                                            <MDBCol sm={12} md={12}>
                                                <div className='mb-4'>
                                                    <MDBTextArea label="Message" id="textAreaExample" rows="{7}"
                                                        value={contact.inquiry}
                                                        onChange={(e) => updateContactForm({ inquiry: e.target.value })}
                                                        required
                                                    />
                                                    {ErrorContactInfo.inquiry && (<p className="text-danger">{ErrorContactInfo.inquiry}</p>)}
                                                </div>
                                            </MDBCol>
                                            <MDBCol sm={12} md={12} className='d-flex justify-content-end'>
                                                <button class="btnn btn-1 hover-filled-slide-down" style={{
                                                    backgroundColor: contactData.button?.bgcolor || '#7b5cfa',
                                                    color: contactData.button?.color || '#ffffff',
                                                    border: contactData.button?.bordercolor,
                                                }} onClick={(e) => sendingMail(e)}>
                                                    <span>{contactData.button?.text || 'Send'}</span>
                                                </button>
                                            </MDBCol>
                                        </MDBRow>
                                    </div>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    </MDBRow>

                </div>
                <div className='backdrop elemt2'>
                    <img src={backdrop} alt="" />
                </div>

            </div>

            <MDBAlert
                color={Alerttxt.includes("Failed") ? "danger" : "success"}
                autohide
                position='top-right'
                delay={4000}
                appendToBody
                open={Alerttxt != ""}
                onClose={() => setAlerttxt("")}
            >
                {Alerttxt}
            </MDBAlert>
        </>
    )
}

export default GymContact
